import { IBlocks, IPages, ITheme, IUserData } from "@/types";

export async function SetUsername(user: IUserData, username: string) {
    try {
        return await fetch(
            process.env.NEXT_PUBLIC_API_SERVER_INTERNAL +
                "/api/admin/settings/username",
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    old_value: user.username,
                    username: username,
                }),
            }
        );
    } catch (error) {
        console.error("Error setting display name:", error);
        const customError: Response = new Response(
            JSON.stringify({
                error: error,
            })
        );
        return customError;
    }
}

export async function SetDisplayName(user: IUserData, displayname: string) {
    try {
        return await fetch(
            process.env.NEXT_PUBLIC_API_SERVER_INTERNAL +
                "/api/admin/settings/display_name",
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    old_value: user.displayname,
                    displayname: displayname,
                }),
            }
        );
    } catch (error) {
        console.error("Error setting display name:", error);
        const customError: Response = new Response(
            JSON.stringify({
                error: error,
            })
        );
        return customError;
    }
}
export async function SetBio(user: IUserData, bio: string) {
    try {
        return await fetch(
            process.env.NEXT_PUBLIC_API_SERVER_INTERNAL +
                "/api/admin/settings/bio",
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    old_value: user.bio,
                    bio: bio,
                }),
            }
        );
    } catch (error) {
        console.error("Error setting bio:", error);
        const customError: Response = new Response(
            JSON.stringify({
                error: error,
            })
        );
        return customError;
    }
}
export async function SetPronouns(user: IUserData, pronouns: string) {
    try {
        return await fetch(
            process.env.NEXT_PUBLIC_API_SERVER_INTERNAL +
                "/api/admin/settings/pronouns",
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    old_value: user.settings.pronouns,
                    pronouns: pronouns,
                }),
            }
        );
    } catch (error) {
        console.error("Error setting bio:", error);
        const customError: Response = new Response(
            JSON.stringify({
                error: error,
            })
        );
        return customError;
    }
}
export async function SetLocation(user: IUserData, location: string) {
    try {
        return await fetch(
            process.env.NEXT_PUBLIC_API_SERVER_INTERNAL +
                "/api/admin/settings/location",
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    old_value: user.settings.location,
                    location: location,
                }),
            }
        );
    } catch (error) {
        console.error("Error setting bio:", error);
        const customError: Response = new Response(
            JSON.stringify({
                error: error,
            })
        );
        return customError;
    }
}
export async function SetProfilePic(user: IUserData, file: string) {
    try {
        return await fetch(
            process.env.NEXT_PUBLIC_API_SERVER_INTERNAL +
                "/api/admin/settings/profile_pic",
            {
                method: "PUT",
                headers: {
                    "Content-Type": "application/octet-stream",
                    "old-file": user.pic,
                },
                body: file,
            }
        );
    } catch (error) {
        console.error("Error setting bio:", error);
        const customError: Response = new Response(
            JSON.stringify({
                error: error,
            })
        );
        return customError;
    }
}
export async function SetShowBranding(user: IUserData, toggle: boolean) {
    try {
        return await fetch(
            process.env.NEXT_PUBLIC_API_SERVER_INTERNAL +
                "/api/admin/settings/branding_toggle",
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    old_value: user.settings.branding,
                    toggle: toggle,
                }),
            }
        );
    } catch (error) {
        console.error("Error setting branding_toggle:", error);
        const customError: Response = new Response(
            JSON.stringify({
                error: error,
            })
        );
        return customError;
    }
}
export async function SetDomainAdd(
    user: IUserData,
    {
        domain,
        challenge,
    }: {
        domain: string;
        challenge: string;
    }
) {
    try {
        return await fetch(
            process.env.NEXT_PUBLIC_API_SERVER_INTERNAL +
                "/api/admin/settings/domain_add",
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    domain,
                    challenge,
                    username: user.username,
                    id: user.id,
                }),
            }
        );
    } catch (error) {
        console.error("Error setting domain:", error);
        const customError: Response = new Response(
            JSON.stringify({
                error: error,
            })
        );
        return customError;
    }
}
export async function SetStaffProToggle(
    user: IUserData,
    account_type: IUserData["account_type"]
) {
    try {
        return await fetch(
            process.env.NEXT_PUBLIC_API_SERVER_INTERNAL +
                "/api/admin/staff/pro_toggle",
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    access: user.access,
                    account_type: account_type,
                    old_value: user.account_type,
                }),
            }
        );
    } catch (error) {
        console.error("Error setting domain:", error);
        const customError: Response = new Response(
            JSON.stringify({
                error: error,
            })
        );
        return customError;
    }
}
export async function UpdateBlocks(
    user: IUserData,
    blocks: IBlocks[],
    impersonate?: boolean
) {
    try {
        return await fetch(
            process.env.NEXT_PUBLIC_API_SERVER_INTERNAL +
                "/api/admin/blocks/blocks_update",
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    impersonate: impersonate ? user.id : null,
                    old_blocks: user.links,
                    blocks: blocks,
                }),
            }
        );
    } catch (error) {
        console.error("Error setting bio:", error);
        const customError: Response = new Response(
            JSON.stringify({
                error: error,
            })
        );
        return customError;
    }
}
export async function UpdateBlocksPage(
    user: IUserData,
    blocks: IBlocks[],
    page: IPages,
    impersonate?: boolean
) {
    try {
        return await fetch(
            process.env.NEXT_PUBLIC_API_SERVER_INTERNAL +
                "/api/admin/pages/blocks/blocks_update",
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    old_blocks: page.blocks,
                    blocks: blocks,
                    id: page.id,
                    impersonate: impersonate ? user.id : null,
                }),
            }
        );
    } catch (error) {
        console.error("Error setting bio:", error);
        const customError: Response = new Response(
            JSON.stringify({
                error: error,
            })
        );
        return customError;
    }
}
export async function ThemeUpdateLayout(
    user: IUserData,
    layout: ITheme["layout"],
    impersonate?: boolean
) {
    try {
        return await fetch(
            process.env.NEXT_PUBLIC_API_SERVER_INTERNAL +
                "/api/admin/theme/layout",
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    old_layout: user.theme.layout,
                    layout: layout,
                    impersonate: impersonate ? user.id : null,
                }),
            }
        );
    } catch (error) {
        console.error("Error theme layout:", error);
        const customError: Response = new Response(
            JSON.stringify({
                error: error,
            })
        );
        return customError;
    }
}
export async function designUpdate(
    user: IUserData,
    design: IUserData["design"],
    impersonate?: boolean
) {
    try {
        return await fetch(
            process.env.NEXT_PUBLIC_API_SERVER_INTERNAL +
                "/api/admin/theme/design",
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    old_design: user.design,
                    design: design,
                    impersonate: impersonate ? user.id : null,
                }),
            }
        );
    } catch (error) {
        console.error("Error theme layout:", error);
        const customError: Response = new Response(
            JSON.stringify({
                error: error,
            })
        );
        return customError;
    }
}
export async function ThemeUpdateTextColorHeading(
    user: IUserData,
    value: ITheme["text_col_heading"],
    impersonate?: boolean
) {
    try {
        return await fetch(
            process.env.NEXT_PUBLIC_API_SERVER_INTERNAL +
                "/api/admin/theme/text_color_heading",
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    old_value: user.theme.text_col_heading,
                    value: value,
                    impersonate: impersonate ? user.id : null,
                }),
            }
        );
    } catch (error) {
        console.error("Error theme text_color_heading:", error);
        const customError: Response = new Response(
            JSON.stringify({
                error: error,
            })
        );
        return customError;
    }
}
export async function ThemeUpdate(
    user: IUserData,
    value: ITheme,
    impersonate?: boolean
) {
    try {
        return await fetch(
            process.env.NEXT_PUBLIC_API_SERVER_INTERNAL +
                "/api/admin/theme/theme",
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    old_value: user.theme,
                    value: value,
                    impersonate: impersonate ? user.id : null,
                }),
            }
        );
    } catch (error) {
        console.error("Error theme update:", error);
        const customError: Response = new Response(
            JSON.stringify({
                error: error,
            })
        );
        return customError;
    }
}
